// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import McMullen from '../../../Texas/data/counties/McMullen.geo.json'
import Live_Oak from '../../../Texas/data/counties/Live_Oak.geo.json'
import Bee from '../../../Texas/data/counties/Bee.geo.json'
import Refugio from '../../../Texas/data/counties/Refugio.geo.json'
import Aransas from '../../../Texas/data/counties/Aransas.geo.json'
import Duval from '../../../Texas/data/counties/Duval.geo.json'
import Jim_Wells from '../../../Texas/data/counties/Jim_Wells.geo.json'
import San_Patricio from '../../../Texas/data/counties/San_Patricio.geo.json'
import Nueces from '../../../Texas/data/counties/Nueces.geo.json'
import Kleberg from '../../../Texas/data/counties/Kleberg.geo.json'
import Brooks from '../../../Texas/data/counties/Brooks.geo.json'
import Kenedy from '../../../Texas/data/counties/Kenedy.geo.json'

const counties = {
  McMullen,
  Live_Oak,
  Bee,
  Refugio,
  Aransas,
  Duval,
  Jim_Wells,
  San_Patricio,
  Nueces,
  Kleberg,
  Brooks,
  Kenedy
}

export default counties
